export const versionInfo = {
  GitCommit: '',
  GitBranch: '',
  TfsReleaseName: '',
  ReleaseUrl: '',
  TfsReleaseUrl: '',
  ReleaseName: '',
  BuildNumber: 'Development',
};
